var RakeNonFederatedResultItem = React.createClass({
  propTypes: {
    hit: React.PropTypes.object.isRequired,
    showStars: React.PropTypes.bool,
    showSummary: React.PropTypes.bool,
    showHitSummary: React.PropTypes.bool,
	queryText: React.PropTypes.string,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired
  },
  emailClicked(hit, e) {
    this.props.onEmailClicked(hit, e);
  },
  previewClicked(hit, e) {
    this.props.onPreviewClicked(hit, e);
  },
  getDefaultProps() {
    return {
      showStars: false,
      showSummary: true,
      showHitSummary: true,
	  queryText: ""
    }
  },
  getCleanHitSummary() {
    let hitSummary = this.props.hit.hitSummary;
	if(hitSummary === null || hitSummary === undefined) {
		return "";
	}
    hitSummary = hitSummary.replace(/<B>/g, "raopenbold").replace(/<\/B>/g, "raclosebold");
    hitSummary = hitSummary.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    return hitSummary.replace(/raopenbold/g, "<B>").replace(/raclosebold/g, "</B>");
  },
  getIconClassName() {
    return "glyphicon-transfer";
  },
  renderSummary() {
    if (!this.props.showSummary) return;

    let { hit } = this.props;

    let fileTypeTag = hit.solution.type == "Document" ? <span>[{hit.solution.iconCode}] </span> : null;

    return (
      <div className="view-link__summary">
        {fileTypeTag}
        <span dangerouslySetInnerHTML={{__html:hit.summary}}></span>
      </div>
    );
  },
  renderHitSummary() {
    if (!this.props.showHitSummary) return;

    return <div className="view-link__hit-summary" dangerouslySetInnerHTML={{__html: this.getCleanHitSummary()}}></div>;
  },
  renderStarImage() {
    if (!this.props.showStars) return;

    let score = this.props.hit.score;
    let stars = 1;

    if (score > .8) {
      stars = 5;
    } else if (score > .6 && score < .8) {
      stars = 4;
    } else if (score > .4 && score < .6) {
      stars = 3;
    } else if (score > .2 && score < .4) {
      stars = 2;
    }

    return <span className={"star-rating -star" + stars}></span>;
  },
  renderIsNewUpdatedLabel() {
      if (!this.props.hit.solution.isNewUpdated) return;

      let displayIsNewUpdated = (this.props.hit.solution.isNewUpdated === 1 ? Labels.getLabel('NEW') : Labels.getLabel('UPDATED'));

      if (this.renderStarImage() === undefined) {
        return (
          <span className="label label-default">{displayIsNewUpdated}</span>
        );
      } else {
        return(
          <span>
            <span>&nbsp;</span>
            <span className="label label-default">{displayIsNewUpdated}</span>
          </span>
        );
      }
  },
  openLink(e) {
    let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

    let ticketId = "";
    if(Config.copyToIncidentEnabled) {
        ticketId = `&ticketid=` + $("#ticketID").val();
    }

    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;

    if (hit.solution.type === "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;

        let logData = {
            action: "VIEWRAKEDOCUMENT",
            docid: hit.solution.id,
            description: hit.solution.title,
            typeofview: "other_externalsource",
            accessmethod: sessionStorage.getItem("accessmethod")
        };

        RA.logAction(logData);
    }

	if (launchLinksInNewWindow) {
		e.preventDefault();
		RA.Utils.openCenteredWindow(url, '1100', '800');
	}
  },
  renderEmailButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="email-link" style={divStyle} title="Email Solution" onClick={this.emailClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-envelope"></i></small>
          </a>
        </li>
    )
  },
  renderPreviewButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="preview-link" style={divStyle} title="Preview" onClick={this.previewClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-search"></i></small>
          </a>
        </li>
    )
  },
  render() {
    let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

	var divStyle = {
        float: "right",
        margin: "7px"
    };

    let target = "_self";
    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let className = `view-link__title s-${hit.solution.isSolr}`;

    if (hit.solution.type == "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;
        target = "_blank";
    }

    return (
      <li className="view-link">
        <div className="view-link__icon">
          <i className={"glyphicon " + this.getIconClassName()}></i>
        </div>
        <div className="view-link__content">
          <a onClick={this.openLink} href={url} target={target} className={className} dangerouslySetInnerHTML={{__html: hit.solution.title}}></a>
          <div className="view-link__subhead">
            <ul className="actions">
              {this.renderEmailButton(divStyle, hit)}
              {this.renderPreviewButton(divStyle, hit)}
            </ul>
            {this.renderSummary()}
            {this.renderHitSummary()}
            <div className="view-link__sub-line">
              {this.renderStarImage()}
              {this.renderIsNewUpdatedLabel()}
            </div>
          </div>
        </div>
        <div className="preview-pane muted">
          <div className="content">
            <div >
              <strong>{Labels.getLabel("Preview")}</strong>
            </div>
            <div className="solution"></div>
          </div>
        </div>
      </li>
    )
  }
})